export const entityTypes = {
  country: {
    key: 'country',
    label: 'Страна',
  },
  region: {
    key: 'region',
    label: 'Регион',
    dependencies: [{ label: 'Страна', name: 'country' }],
    manyName: 'countries',
  },
  city: {
    key: 'city',
    label: 'Город',
    dependencies: [{ label: 'Регион', name: 'region' }],
    manyName: 'regions',
  },
  factory: {
    key: 'factory',
    label: 'Фабрика',
    dependencies: [{ label: 'Страна', name: 'country' }],
    manyName: 'countries',
  },
};



// WEBPACK FOOTER //
// ./src/scenes/Stores/config.ts